import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * 顧客詳細のフォームのベースです。
 * NOTE: Chakra の Text は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const DetailFormBase: FC<Props> = ({ register }) => (
  <Input
    id="detail"
    type="text"
    {...register('detail', {
      required: '必須項目です。',
      maxLength: {
        value: 100,
        message: '顧客詳細は 255 文字以内にする必要があります。',
      },
    })}
  />
);
